import Logo from "components/atoms/CompanyLogo/Logo";
import styles from "components/molecules/Login/login.module.css";

type ComponentProps = {
	children?: JSX.Element;
	isSubHeader?: boolean;
	subHeader?: string;
	isDisclaimer?: boolean;
	disclaimerText?: string;
	showDesign?: boolean;
	hideLogo?: boolean;
	page?: string;
	isDescription?: boolean;
	description?: string;
	isWarningMessage?: boolean;
	warningText?: string;
};

const Login = ({
	children,
	isDescription,
	description,
	isSubHeader,
	subHeader,
	isDisclaimer,
	disclaimerText,
	isWarningMessage,
	warningText,
	showDesign,
	hideLogo,
	page
}: ComponentProps) => {
	const loginWrapperClass = page ? styles?.[`login_wrapper_${page}`] : styles?.login_wrapper;

	return (
		<div className={styles?.root}>
			<div className={styles?.bottom_ellipse_wrapper}>
				{showDesign && (
					<>
						<div className={styles?.bottom_ellipse}>
							<svg width="101" height="123" viewBox="0 0 101 123" fill="none" xmlns="http://www.w3.org/2000/svg">
								<ellipse cx="6.32394" cy="94.3736" rx="94.3239" ry="93.6129" fill="#EE362E" fillOpacity="0.7" />
							</svg>
						</div>
						<div className={styles?.top_ellipse}>
							<svg width="155" height="51" viewBox="0 0 155 51" fill="none" xmlns="http://www.w3.org/2000/svg">
								<ellipse cx="94.3239" cy="-39.5" rx="94.3239" ry="90.5" fill="#F58029" fillOpacity="0.8" />
							</svg>
						</div>
						<div className={styles?.top_right_ellipse}>
							<svg width="116" height="177" viewBox="0 0 116 177" fill="none" xmlns="http://www.w3.org/2000/svg">
								<ellipse cx="111.648" cy="70.5" rx="111" ry="106.5" fill="#63267B" fillOpacity="0.6" />
							</svg>
						</div>
					</>
				)}
				<div className={loginWrapperClass}>
					{!hideLogo && (
						<div className={styles?.logo_wrapper}>
							<Logo />
						</div>
					)}
					{isDisclaimer && (
						<div className={styles?.message_wrapper}>
							<p className={styles?.disclaimer_text}>{disclaimerText}</p>
						</div>
					)}
					{isSubHeader && (
						<div className={styles?.message_wrapper}>
							<p className={styles?.subheader_text}>{subHeader}</p>
						</div>
					)}
					{isWarningMessage && (
						<div className={styles?.message_wrapper}>
							<p className={styles?.disclaimer_text}>{warningText}</p>
						</div>
					)}
					{isDescription && (
						<div className={`${styles?.message_wrapper} text-center`}>
							<p className={styles?.description}>{description}</p>
						</div>
					)}
					<div className={styles?.form_wrapper}>{children}</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
